import React from 'react';
import './Header.scss';
import logo_macif from '../../../public/image/logo_macif-assistance.png';

const Header = ({titre}) => {
    return (
        <header>
            <div className="header">
                <h1>
                    <a href="https://www.macif.fr/">
                        <img src={logo_macif} alt="Logo" border="0"/>
                    </a>
                </h1>
                <div className="title-header">
                    <span><b>{titre}</b></span>
                </div>
                <div id="mynav" className="content-space"></div>
            </div>
        </header>
    );
};
export default Header;
